import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('LogoWrapper', [
  'base',
  'medium',
]);

const getLogoWrapperCss = () => css`
  &.${classes.base} {
    display: block;
    width: fit-content;
    background-color: light-dark(transparent, #fff);

    /* when an image fails to load, alt text should be visible */
    color: light-dark(initial, #000);
    border-radius: var(--cds-logo-wrapper-padding, 0);
    padding: var(--cds-logo-wrapper-padding, 0);
    margin: calc(var(--cds-logo-wrapper-padding, 0) * -1);
    &.${classes.medium} {
      border-radius: calc(var(--cds-logo-wrapper-padding, 0) * 2);
      padding: calc(var(--cds-logo-wrapper-padding, 0) * 2);
      margin: calc(var(--cds-logo-wrapper-padding, 0) * -2);
    }
  }
`;

export default getLogoWrapperCss;
